module.exports = __webpack_public_path__ + "img/CliSet1.9506d86b.jpg";